module.exports = __webpack_public_path__ + "img/star.ba627118.svg";